<template>
  <div class="moe">
    <materials-order-unit-toggle v-if="hasBoxes" :mode="mode" :item-name="item.name" @change="switchMode" />
    <materials-order-custom-quantity
      ref="input"
      :value="text"
      :material-id="item.material_id"
      :item-name="item.name"
      :max-digits="maxDigits"
      :unit="model.unitLabel"
      @input="typeQuantity"
      @clear="clearQuantity"
    />
    <span v-if="model.hint" class="moe-hint">{{ model.hint }}</span>
    <span v-if="model.isInvalid" class="moe-error">Ingresa una cantidad entre 1 y {{ maxQuantityLabel }}.</span>
  </div>
</template>

<script>
import MaterialsOrderCustomQuantity from './MaterialsOrderCustomQuantity.vue';
import MaterialsOrderUnitToggle from './MaterialsOrderUnitToggle.vue';
import { formatQuantity } from './materialsOrderSelection';
import { UNITS_MODE, entryRowModel, hasUnitsPerBox, unitsToModeText } from './materialsOrderBoxes';

export default {
  name: 'MaterialsOrderQuantityEntry',
  components: { MaterialsOrderCustomQuantity, MaterialsOrderUnitToggle },
  props: {
    item: { type: Object, required: true },
    maxQuantity: { type: Number, required: true },
    quantity: { type: Number, default: null },
  },
  data() {
    return {
      mode: UNITS_MODE,
      text: this.quantity === null ? '' : String(this.quantity),
    };
  },
  computed: {
    hasBoxes() {
      return hasUnitsPerBox(this.item);
    },
    model() {
      return entryRowModel({ item: this.item, mode: this.mode, text: this.text, maxQuantity: this.maxQuantity });
    },
    maxDigits() {
      return String(this.maxQuantity).length;
    },
    maxQuantityLabel() {
      return formatQuantity(this.maxQuantity);
    },
  },
  methods: {
    typeQuantity(digits) {
      this.text = digits;
      this.$emit('change', this.model.quantity);
    },
    clearQuantity() {
      this.typeQuantity('');
    },
    switchMode(mode) {
      this.text = unitsToModeText(this.model.quantity, mode, this.item);
      this.mode = mode;
      this.$emit('change', this.model.quantity);
      this.$nextTick(() => this.$refs.input.focus());
    },
  },
};
</script>

<style scoped>
.moe {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
}
.moe-hint {
  font-size: 12px;
  font-weight: 600;
  color: #01662E;
}
.moe-error {
  font-size: 12px;
  color: #b91c1c;
}
</style>
